/* eslint-disable camelcase */
/* eslint-disable no-undef */
import $ from 'jquery';

import App from './modules/App';
import { AppInit } from './modules/Init';
import { Filters } from './modules/Filter';
import { Get } from './modules/Get';
import { IconWishlist, IconBasket } from './modules/Icons';
import ScrollTop from './modules/ScrollTop';

$.fn.textWidth = function getTextWidth(text, font) {
  if (!$.fn.textWidth.fakeEl) {
    $.fn.textWidth.fakeEl = $('<span>').hide().appendTo(document.body);
  }
  $.fn.textWidth.fakeEl.text(text || this.val() || this.text()).css('font', font || this.css('font'));
  return $.fn.textWidth.fakeEl.width();
};

App.fn.categoryDivider = function categoryDivider(selector) {
  const descriptionTop = selector || '.search_categoriesdescription_sub';
  const children = $(descriptionTop).children();
  let categorySize = App.vars.categorySize !== undefined ? App.vars.categorySize : 256;
  if (children.length > 1 && !$('.search_categoriesdescription_next').length && categorySize !== 0) {
    $(descriptionTop).after(
      `<button type="button" class="show_description d-none d-md-block">
          <span>${Literals.search.readMore}</span>
      </button>`,
    );
    $('.categoryDescBot').append(`<div class="search_categoriesdescription_next cm"></div>`);
    $.each(children, (indexInArray, valueOfElement) => {
      const amountWithElementLength = (categorySize - valueOfElement.innerText.length) * -1;

      if (
        categorySize - valueOfElement.innerText.length <= 0 &&
        amountWithElementLength >= categorySize &&
        indexInArray
      ) {
        $(valueOfElement).appendTo('.search_categoriesdescription_next');
      }
      categorySize -= valueOfElement.innerText.length;
    });
  }
  $(descriptionTop).removeClass('--skeleton');
  return false;
};

App.fn.searchUpsellingProduct = (product, wrapper) => {
  const {
    name,
    icon,
    attributes: { id, link },
    price: {
      attributes: { worth_formatted },
    },
  } = product;

  wrapper.prepend(
    `<figure class="product__icon">
      <a class="product__icon-link" href="${link}">
        <img src="${icon}" />
      </a>
    </figure>`,
  );
  wrapper.find('.product__inner').append(
    `<a class="product__name" href="${link}">${name}</a>
      <div class="product__bottom d-flex justify-content-between align-items-center">
        <strong class="price">${worth_formatted}</strong>
        <div class="product__actions">
          <button type="button" class="btn --solid --secondary --wishlist ${
            product.isWishlist && '--observed'
          }" data-mode="2" data-product="${id}">
           ${IconWishlist}
          </button>
          <button type="button" class="btn --solid --cart" data-product="${id}">
           ${IconBasket}
          </button>
        </div>
      </div>`,
  );

  $('.placeholder__heading').addClass('col-md-8');
  $('.placeholder__upselling').removeClass('d-none');
};

App.run(() => {
  App.fn.categoryDivider('.search__content');

  $(document).on('click', 'button.show_description', () => {
    const y = document.getElementById('description_more').getBoundingClientRect().top + window.pageYOffset + (-62);

    window.scrollTo({ top: y, behavior: 'smooth' });
    return false;
  });

  App.fn.replaceSelects($('.f-select-sort, .f-select-pagin'), '', ($elem) => {
    App.fn.dropdownClick($elem, true);
  });

  $('.s_paging__item.--filters').on('click', () => {
    $('html').addClass('filters_open');
  });

  const upsellingWrapper = $('.search__upselling');
  if (upsellingWrapper.length && upsellingWrapper.data('product')) {
    Get.Product(upsellingWrapper.data('product'), ({ Product, Wishlist }) => {
      // eslint-disable-next-line eqeqeq
      const productFind = Product.response.product.find((el) => el.attributes.id == upsellingWrapper.data('product'));

      if (
        Wishlist.response.product &&
        Wishlist.response.product.filter((el) => el.attributes.id === productFind.attributes.id).length
      ) {
        productFind.isWishlist = true;
      }

      if (productFind) {
        App.fn.searchUpsellingProduct(productFind, upsellingWrapper);
      }
    });
  }

  $(document).on('click', '.search .product a', function goToProduct(e) {
    sessionStorage.setItem('goTo_search', $(this).attr('href'));
  });

  $(document).on('click', '.search__load-next .btn', function clickLoadnextPage(e) {
    e.preventDefault();
    const self = $(this);
    const ajaxConfig = {
      url: self.data('link'),
      success: (html) => {
        App.fn.changeUrlNotHistory(self.data('link'));

        const products = $(html).find('.search .product__outer');
        const nextPage = $(html).find('.search__next-page');

        const topOffset = $('.search .product__outer:not(.--disabled)').last().offset().top - 121;
        $('.search').append(products);
        $('.search__next-page').replaceWith(nextPage);
        App.vars.bLazy.revalidate();
        App.fn.splitFirmSearch();
        $('html, body').animate({
          scrollTop: topOffset,
        }, 500);
      },
    };

    self.addClass('--loading');
    $.ajax(ajaxConfig);
  });

  const goTo_search = sessionStorage.getItem('goTo_search');
  const params = new URLSearchParams(window.location.search);
  const page = params.get('counter');
  const pages = [];
  if (page) {
    $(document).ready(async () => {
      $('.search').addClass('load-content');
      for (let i = page - 1; i > -1; i -= 1) {
        const ajaxConfig = {
          url: `${window.location.origin}${window.location.pathname}?counter=${i}`,
          // success: (html) => {
          //   const products = $(html).find('.search .product__outer');

          //   $('.search').prepend(products);
          //   App.vars.bLazy.revalidate();
          //   App.fn.splitFirmSearch();
          // },
        };

        pages.push($.ajax(ajaxConfig));
      }
      await Promise.all(pages).then((html) => {
        for (let i = 0; i < html.length; i++) {
          const products = $(html[i]).find('.search .product__outer');

          $('.search').prepend(products);
          App.vars.bLazy.revalidate();
          App.fn.splitFirmSearch();
        }
      });
      $('.search').removeClass('load-content');
      if (goTo_search) {
        $('html, body').animate({
          scrollTop: $(`a[href="${goTo_search}"]`).first().parents('.product__outer').offset().top - 121,
        }, 500);
      } else {
        $('html, body').animate({
          scrollTop: $('.search .product__outer:not(.--disabled)').last().offset().top - 121,
        }, 500);
      }
    });
  } else if (goTo_search) {
    if ($(`a[href="${goTo_search}"]`).first().parents('.product__outer').offset()) {
      $('html, body').animate({
        scrollTop: $(`a[href="${goTo_search}"]`).first().parents('.product__outer').offset().top - 121,
      }, 500);
    }
  }



  App.fn.splitFirmSearch();
  sessionStorage.removeItem('goTo_search');
}, 'all');

App.run(
  () => {
    $('aside').append($('#Filters'));
  },
  [1],
  '#Filters',
);

App.run(
  () => {
    $('.search__heading').after($('#Filters'));
  },
  [2, 3, 4, 5],
  '#Filters',
);

// funkcja callback która dodaje eventy do elementów klikalnych
const filtersActionsCall = () => {
  // Rozwiń/ukryj liste elementów listy
  $('.filters__options .--show-hidden').on('click', function toggleHiddenElementsInContent() {
    const id = $(this).data('id');
    const content = `#${id}_content`;

    $(content).toggleClass('--shown');
    $(this).toggleClass('--shown');

    return false;
  });

  // Zwiń rozwiń dany filter
  $('.filters__toggler:not(.--not-expandable)').on('click', function toggleVisibilityExpandMenu() {
    const id = $(this).data('id');
    const expand = `#${id}_expand`;

    const active = $('.filters__toggler:not(.--not-expanded)');

    if (id !== active.data('id')) {
      active.addClass('--not-expanded');
      active.next().addClass('--not-expanded');
    }

    $(expand).toggleClass('--not-expanded');
    $(this).toggleClass('--not-expanded');

    return false;
  });

  // Pokaż przycisk "zastosuj"
  $('.filters__item .f-control[type=checkbox]').on('change', function showParentSubmitButtonOnChange() {
    const self = $(this);
    const element = self.parents('.filters__content:not(.--group)').siblings().find('.--submit.d-none');

    if (element.length) element.removeClass('d-none');
  });

  // Rozszerza szerokość inputa na podstawie szerokości wpisanej wartość
  $('#PriceRangeFrom, #PriceRangeTo').on('keyup', function changeInputWidthOnKeyUp() {
    const self = $(this);
    const value = self.val();
    self.val(self.val().replace(/[^0-9]/g, ''));

    const inWidth = $.fn.textWidth(value, '14px Arial');
    self.width(inWidth + 10);
  });
  $('#PriceRangeFrom, #PriceRangeTo').keyup();

  $('.filters__search .f-control').on('keyup', function searchInExpandedFilters() {
    const self = $(this);
    const parent = self.parents('.filters__expand');

    if (self.val()) {
      $.each(parent.find('.filters__item'), function nodeLoop() {
        if ($(this).text().includes(self.val())) {
          $(this).removeClass('d-none');
        } else {
          $(this).addClass('d-none');
        }
      });
    } else {
      parent.find('.filters__item').removeClass('d-none');
    }
  });
};

App.run(
  () => {
    App.vars.filtersRef = new Filters({
      funcActionCall: filtersActionsCall,
      getQuantity: true,
      funcAjaxLoad: () => {
        App.vars.bLazy.revalidate();

        const active = $('.filters__toggler:not(.--not-expanded)');
        active.addClass('--not-expanded');
        active.next().addClass('--not-expanded');

        App.fn.splitFirmSearch();

        if (App.vars.view === 1) {
          $('html').removeClass('filters_open');
        }
      },
    });
  },
  'all',
  '#Filters',
);

AppInit();
